import { YupSchema } from 'services/yup/types'
import { yupString, yupIgnore, yupNumber, yupObject } from 'services/yup'
import { Coupon } from 'services/api/entities/accounting/coupon/types/internal/coupon-models'

export const couponVS: YupSchema<Coupon> = yupObject().shape({
  id: yupIgnore(),
  name: yupString().required(),
  code: yupString().required(),
  startDate: yupString().required(),
  endDate: yupString().required(),
  cartMinimumAmount: yupNumber().required(),
  discountPerc: yupNumber().required(),
  enabled: yupIgnore(), // FIXME: should it really be ignored or should it be mandatory
  oncePerUser: yupIgnore(), // FIXME: should it really be ignored or should it be mandatory
})
